import React, { useEffect, useContext, useRef } from "react";
import CourseAnchorNav from './courseAnchorNav';
import CourseInstancesContainer from './courseInstancesContainer';
import CourseAddOns from './courseAddOns';
import UpcomingCourseDates from "./upcomingCourseDates";
import OnlineRegisterButton from "./onlineRegisterButton";

// import icons
import PlayButtonBlack from '../../../../../img/button-play-circle-black.svg';
import IconVirtual from '../../../../../img/icon-virtual.svg';

//import redux components
import { useSelector } from 'react-redux';
//import context
import { Context } from '../courseTemplates';


/**
 * Container component holding all the course details
 * @param {Object} courseDetails - Object containing all the wordpress course template details
 */
function CourseDetailsPage({courseDetails}) {

    const activeCourseName = useSelector((state) => state.activeCourseName.value)

    // get our global context variables
    const value = useContext(Context);
    const { loggedIn } = value;

    // active course details from WP database
    const activeCourseDetails = courseDetails[activeCourseName];

    // get online course record id if we have one
    const onlineCourseRecordId = activeCourseDetails.onlineCourseRecordId ? activeCourseDetails.onlineCourseRecordId : false;

    // Create a ref for the digital-details section
    const digitalDetailsRef = useRef(null);

    // remove loading classes
    useEffect(() => {
        document.querySelector('.course-details-page').classList.add('loaded');
        document.querySelector('.course-details-page').classList.remove('loading');
    }, []);

    // Scroll to digital-details when the ref is set and hash matches
    useEffect(() => {
        if (digitalDetailsRef.current && window.location.hash === '#digital-details') {
            // Wait for other components to render before
            // scrolling for accurate positioning and then, update the URL to remove the hash
            setTimeout(() => {
                digitalDetailsRef.current.scrollIntoView({ behavior: 'smooth' });
                history.replaceState({}, "", "/courses/" + activeCourseName + "/");
            }, 2000);
        }
    }, [digitalDetailsRef.current]);

    // Component level JSX return statement ******************************************************
    return (
        <div className="course-details-page loading">

            {/* PAGE ANCHOR NAVIGATION */}
            <CourseAnchorNav courseDetails={activeCourseDetails}/>

            {/* Upcoming Course Dates Ribbon */}
            <UpcomingCourseDates courseRecordId={activeCourseDetails.methodRecordId}
                                 onlineCourseRecordId={onlineCourseRecordId}
                                 courseNumber={activeCourseDetails.courseNumber}
                                 onlineOnly={activeCourseDetails.onlineOnly}
                                 courseRibbonShouldRedirect={activeCourseDetails.courseRibbonShouldRedirect}
                                 courseRibbonText={activeCourseDetails.courseRibbonText}
                                 courseRibbonUrl={activeCourseDetails.courseRibbonUrl}
            />

            
            {activeCourseDetails.postContent && 
                <section id="overview" className="pattern-block pattern-block--standard-content">
                    <div className="container">
                        <h2 className="pattern-block__headline border-headline">Overview</h2>
                        <div className="rtecontent" dangerouslySetInnerHTML={{__html: activeCourseDetails.postContent}}/>
                    </div>
                </section>
            }

            {activeCourseDetails.objectives &&
                <section id="objectives" className="pattern-block pattern-block--standard-content">
                    <div className="container">
                        <h2 className="pattern-block__headline border-headline">Course Objectives</h2>
                        <div className="rtecontent">
                            <ul>
                                {activeCourseDetails.objectives.map((objective) => {
                                    return(<li>{objective}</li>)
                                })}
                            </ul>
                        </div>
                    </div>
                </section>
            }

            {activeCourseDetails.courseSchedule &&
                <section id="schedule" className="pattern-block pattern-block--standard-content">
                    <div className="container">
                        <h2 className="pattern-block__headline border-headline">Course Schedule</h2>
                        <div className="rtecontent" dangerouslySetInnerHTML={{__html: activeCourseDetails.courseSchedule}}/>
                    </div>
                </section>
            }

            {activeCourseDetails.courseDetails &&
                <section id="details" className="pattern-block pattern-block--standard-content">
                    <div className="container">
                        <h2 className="pattern-block__headline border-headline">Course Details</h2>
                        <div className="rtecontent" dangerouslySetInnerHTML={{__html: activeCourseDetails.courseDetails}}/>
                    </div>
                </section>
            }

            {onlineCourseRecordId &&
                <section ref={digitalDetailsRef} id="digital-details" className="pattern-block pattern-block--dark">
                    <div className="container">
                        <h2 className="pattern-block__headline border-headline">
                            <span>Digital Course Details<PlayButtonBlack/>{activeCourseDetails.vrAvailable && <IconVirtual/>}</span></h2>
                        <div className="rtecontent" dangerouslySetInnerHTML={{__html: activeCourseDetails.digitalCourseDetails}}/>
                            {/* {getOnlineCourseRegisterButton()} */}
                            {loggedIn &&
                                <OnlineRegisterButton courseRecordId={activeCourseDetails.methodRecordId} darkMode={true}></OnlineRegisterButton>
                            }
                            {!loggedIn &&
                                <>Login to Register</>
                            }
                    </div>
                </section>
            }

            {/* if course has addons */}
            {activeCourseDetails.courseAddOns && 
                <CourseAddOns courseAddOns={activeCourseDetails.courseAddOns} />
            }

            {/* Course Instances Tables/Accordions */}
            <CourseInstancesContainer 
                allCourseDetails={courseDetails} 
                activeCourseName={activeCourseName} 
                courseRecordId={activeCourseDetails.methodRecordId} 
                onlineCourseRecordId={onlineCourseRecordId}
            />

        </div>
    );
}

export default CourseDetailsPage;